// extracted by mini-css-extract-plugin
export default {"addCmt":"AddComment_addCmt__Zbj+o","addCmt-img":"AddComment_addCmt-img__bBt-0","addCmt-btn":"AddComment_addCmt-btn__Mq91u"};